import React from 'react';
import { useTranslation } from 'react-i18next';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import ScanDocument from '@/modules/investments/cip/Questionnaire/ScanDocument';

const ScanDocumentPage = () => {
  const { t } = useTranslation();
  useBreadcrumbs([{
    key: ROUTES.HOME,
    title: t('Home'),
    value: ROUTES.HOME,
  }, {
    key: ROUTES.POLL,
    title: t('Document Upload'),
    value: ROUTES.POLL,
  },
  ], true);

  return (
    <ScanDocument />
  );
};

export default ScanDocumentPage;
